import {asset} from 'imba';
import url from './logo.png';
export default asset({
	url: url,
	type: 'image',
	width: 112,
	height: 206,
	toString: function(){ return this.url;}
})